import React from "react"

export default function Footer() {
  const fecha = new Date()
  const anio = fecha.getFullYear()
  return (
    <footer className="bg-white rounded-lg shadow m-4 z-10">
      <div className="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-center">
        <span className="text-sm text-gray-500 sm:text-center">
          © {anio} Asociart - Legales
        </span>
       
      </div>
    </footer>
  )
}
